const MenuArrow = () => {
  return (
    <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#5F738C"
        fillRule="evenodd"
        d="M12.293 5.293c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414l-5 5c-.39.39-1.024.39-1.414 0l-5-5c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0L8 9.586l4.293-4.293z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export { MenuArrow };
